var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "general-setting-container" }, [
    _c("div", { staticClass: "row row1" }, [
      _c("div", { staticClass: "form-item" }, [
        _c("div", { staticClass: "label" }, [
          _c("span", { staticClass: "required" }, [_vm._v("*")]),
          _vm._v(" " + _vm._s(_vm.$t("FORM_LABEL_siteName")) + ":"),
        ]),
        _c(
          "div",
          { staticClass: "input" },
          [
            _c("el-input", {
              attrs: { size: "mini" },
              on: { change: _vm.onSiteNameChange },
              model: {
                value: _vm.siteName,
                callback: function ($$v) {
                  _vm.siteName = $$v
                },
                expression: "siteName",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "row row1" }, [
      _c("div", { staticClass: "form-item" }, [
        _c("div", { staticClass: "label" }, [
          _c("span", { staticClass: "required" }, [_vm._v("*")]),
          _vm._v(" " + _vm._s(_vm.$t("FORM_LABEL_clientName")) + ":"),
        ]),
        _c(
          "div",
          { staticClass: "input" },
          [
            _c("el-input", {
              attrs: { size: "mini" },
              on: { change: _vm.onClientNameChange },
              model: {
                value: _vm.clientName,
                callback: function ($$v) {
                  _vm.clientName = $$v
                },
                expression: "clientName",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }